import React, { useEffect, useState } from "react";
import SendTxTemplate from "./components/SendTxTemplate";
import { InputSendWallet } from "./components/InputSendWallet";
import { SendTransactionStateRecipient } from "../../../store/slices/transactionSlice";
import { Pleb } from "../../../models/Pleb";
import { useLocation, useNavigate } from "react-router-dom";
import { LayoutWithTopBar } from "../../../components/LayoutWithTopBar";
import { useTransaction } from "../../../hooks/useTransaction";
import { useTheme } from "../../../hooks/useTheme";
import RadioButton from "../../../components/RadioButton";

interface SendTxRecipientProps {}

const SendTxRecipient: React.FC<SendTxRecipientProps> = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [plebSelected, setPlebSelected] = useState<Pleb | null>(null);
    const [lnurl, setLnurl] = useState('');
    const {recipient, loading, error, scanRecipient, resetTransaction, membersOnly, setTransactionMembersOnly} = useTransaction();
    const {isMobile} = useTheme();

    useEffect(() => {
        if(location.state && location.state.recipient) 
        {
            if(location.state.recipient.pleb) {
                location.state.recipient.pleb = new Pleb(location.state.recipient.pleb);
            }
            scanRecipientAndCallOnScanRecipient(location.state.recipient)
        }
        else if(location.state?.timestamp) 
        {
            setLnurl('');
            setPlebSelected(null);
            resetTransaction();
        }
    }, [location.state]);

    const scanRecipientAndCallOnScanRecipient = async (recipient: SendTransactionStateRecipient) => {
        let scanData = await scanRecipient(recipient);

        if(scanData.scanData !== null || scanData.recipient !== null) 
        {
            if(scanData.scanData?.fixedAmountMsat)
                navigate('/home/wallet/send/recap');
            else
                navigate('/home/wallet/send/amount');
        }
    }

    const onClickPrevArrow = () => {
        if(isMobile)
            return () => navigate(`/home/wallet`);

        return undefined;
    }
    
    return (
        <LayoutWithTopBar
            breadcrumbs={[
                { title: 'Wallet', onClick: () => navigate('/home/wallet') },
                { title: 'Send' }
            ]}
            onClickPrevArrow={onClickPrevArrow()}
        >
            <SendTxTemplate
                onButtonClick={() => scanRecipientAndCallOnScanRecipient({
                    pleb: plebSelected,
                    lnurl: lnurl
                })}
                buttonDisabled={lnurl === '' && plebSelected === null}
                buttonLoading={loading}
                error={error}
                className="min-h-[450px] justify-start"
                /*afterButton={
                    <div 
                        className="flex flex-row justify-between items-center cursor-pointer gap-2 py-2" 
                        onClick={() => setTransactionMembersOnly(!membersOnly)}
                    >
                        <div className="uppercase font-medium opacity-80">
                            Members only
                        </div>
                        <RadioButton
                            checked={membersOnly ?? false}
                        />
                    </div>
                }*/
            >
                <InputSendWallet
                    onChangeLnurl={(lnurl) => {
                        setPlebSelected(null);
                        setLnurl(lnurl);
                    }}
                    onSelectLnurl={(lnurl) => {
                        scanRecipientAndCallOnScanRecipient({
                            pleb: null,
                            lnurl: lnurl,
                            bulkPayment: null
                        });
                    }}
                    onChangePleb={(pleb) => {
                        setLnurl('');
                        setPlebSelected(pleb);
                    }}
                    onSelectPleb={(pleb) => {
                        scanRecipientAndCallOnScanRecipient({
                            pleb: pleb,
                            lnurl: '',
                            bulkPayment: null
                        });
                    }}
                    onSelectBulkPayment={(bulkPayment) => {
                        scanRecipientAndCallOnScanRecipient({
                            pleb: null,
                            lnurl: '',
                            bulkPayment: bulkPayment
                        });
                    }}
                    defaultRecipient={recipient}
                    timestamp={location.state?.timestamp}
                    showRecentRecipients={location.state?.lnurlWithdraw ? false : true}
                    placeholder={location.state?.lnurlWithdraw ? "LNURL-Withdraw" : "Username, LNURL, LN Address, Country, City or Invoice"}
                    membersOnly={membersOnly}
                />
            </SendTxTemplate>
        </LayoutWithTopBar>
    );
}

export default SendTxRecipient;